import { ChangeDetectionStrategy, Component, Input, OnChanges, signal } from '@angular/core';
import { GameEntityType, GameEntityTypeDetails } from '../../../../../../common/dto/game-entities.dto';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-game-entity-type-icon',
  standalone: true,
  imports: [NgOptimizedImage],
  templateUrl: './game-entity-type-icon.component.html',
  styleUrl: './game-entity-type-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GameEntityTypeIconComponent implements OnChanges {
  @Input({ required: true })
  public type!: GameEntityType;

  @Input({ required: true })
  public width!: number;

  @Input({ required: true })
  public height!: number;

  @Input()
  public priority = false;

  @Input()
  public mode: 'normal' | 'circle' = 'normal';

  protected src = signal<string | undefined>(undefined);

  public ngOnChanges(): void {
    switch (this.type) {
      case GameEntityType.NPC:
        this.src.set('/assets/images/icons/npc-icon.webp');
        break;

      case GameEntityType.Item:
      default:
        this.src.set('/assets/images/icons/item-icon.webp');
        break;
    }
  }

  protected readonly GameEntityTypeTexts = GameEntityTypeDetails;
}
